export default __webpack_public_path__ + "static/media/download.19164261.svg";